import React from 'react';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { Section, Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import { Text, Typography } from '@fiverr-private/typography';
import { Box } from '@fiverr-private/theme';
import { Button } from '@fiverr-private/button';
import { Video } from '@fiverr-private/media';
import pathfinder from '@fiverr-private/pathfinder';
import { getImpressionEnrichment, sendBigQueryEvent } from '../../utils/biEvents';
import { BQ_HOMEPAGE_CLICK, BQ_HOMEPAGE_IMP } from '../../utils/biEvents/events/bigQueryEvents';
import SafeComponent from '../../shared/SafeComponent';
import { AI_BANNER_POSTER_URL, AI_BANNER_UTM_SOURCE, AI_BANNER_VIDEO_URL } from './constants';
import { descriptionClass, mediaWrapperClass, titleClass } from './styles.ve.css';

const AiBannerSection = () => {
    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_HOMEPAGE_IMP }));
    const ctaLink = pathfinder('discover_ai_agents_page', {}, { query: { utm_source: AI_BANNER_UTM_SOURCE } });

    const onButtonClick = () => {
        sendBigQueryEvent({
            eventName: BQ_HOMEPAGE_CLICK,
            params: { elementName: 'ai_video_banner', elementType: 'button' },
        });
    };

    return (
        <Section paddingTop="0" paddingBottom={{ default: '10', sm: '12', md: '12', lg: '10' }}>
            <Stack
                ref={ref}
                direction={{ default: 'column', md: 'row' }}
                paddingTop={{ default: '5', sm: '10', md: '12', xl: '16' }}
                paddingBottom={{ default: '6', sm: '12', md: '12', xl: '16' }}
                paddingX={{ default: '5', sm: '10', xl: '16' }}
                alignItems="center"
                justifyContent="spaceBetween"
                width="100%"
                height="auto"
                gap={{ default: '8', sm: '10', md: '6' }}
                background="#421300"
                borderRadius="2xl"
                overflow="hidden"
            >
                <Stack
                    direction="column"
                    color="white"
                    gap="0"
                    width="100%"
                    maxWidth={{ default: '100%', md: '285px', lg: '528px' }}
                    flexShrink={0}
                    order={{ default: 2, md: 1 }}
                >
                    <Stack direction="column" gap="4" marginBottom="8">
                        <Typography as="h2" color="inherit" className={titleClass}>
                            <I18n k="logged_out_homepage.ai_banner_section.title" />
                        </Typography>
                        <Text color="inherit" className={descriptionClass}>
                            <I18n k="logged_out_homepage.ai_banner_section.description" />
                        </Text>
                    </Stack>
                    <Stack
                        direction="column"
                        gap="4"
                        width={{ default: '100%', sm: '292px', md: 'fit-content' }}
                        alignSelf={{ default: 'center', md: 'flexStart' }}
                    >
                        <Button
                            href={ctaLink}
                            size="lg"
                            fullWidth
                            variant="filled"
                            colorScheme="white"
                            onClick={onButtonClick}
                        >
                            <I18n k="logged_out_homepage.ai_banner_section.cta" />
                        </Button>
                    </Stack>
                </Stack>
                <Box
                    className={mediaWrapperClass}
                    order={{ default: 1, md: 2 }}
                    position="relative"
                    overflow="hidden"
                    width="100%"
                    minWidth={0}
                >
                    <Video
                        width="100%"
                        objectFit="contain"
                        autoPlay
                        playsInline
                        controls={false}
                        loop
                        muted
                        preload="auto"
                        poster={AI_BANNER_POSTER_URL}
                        aria-hidden
                        sources={[
                            {
                                src: AI_BANNER_VIDEO_URL,
                                type: 'video/mp4',
                            },
                        ]}
                    />
                </Box>
            </Stack>
        </Section>
    );
};

export { AiBannerSection };
export default SafeComponent(AiBannerSection);
